<template>
    <list-widget title="결제수단" minWidth="200" #default="{ attrs }">
        <v-select v-model="query['payment.method']" v-bind="{ ...attrs, items }" dense flat solo hide-details @input="emit" />
    </list-widget>
</template>

<script>
import { NSHOP_ORDER_PAYMENT_METHODS } from "@/store/nshop";
import ListWidget from "../../dumb/list/list-widget.vue";

const items = [{ value: null, text: "전체" }].concat(...Object.values(NSHOP_ORDER_PAYMENT_METHODS));

const initQuery = (query = {}) => ({
    ...(query || {}),

    ["payment.method"]: query?.["payment.method"] || null,
});

export default {
    components: {
        ListWidget,
    },
    data: () => ({
        query: initQuery(),
        items,
    }),
    methods: {
        sync() {
            this.query = initQuery(this.$route.query);
        },
        emit() {
            let { ...query } = this.query;
            delete query["page"];
            if (!query["payment.method"]) delete query["payment.method"];
            this.$router.push({ query });
        },
    },
    watch: {
        $route() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style lang="scss" scoped></style>
